import axiosClient from "../../../utils/axios";
import { ApiResponse } from "../../../types/api.types";
import { Questionnaire } from "../types/questionnaire.types";
import { SurveyAnswerResponse, SaveSurveyRequest } from "../types/survey.types";

export const getQuestionnaire = async (id: number) => {
  try {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("Invalid ID");
    }
    const response = await axiosClient.post<ApiResponse<Questionnaire>>(
      `/questionnaire/view`,
      {
        id,
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Questionnaire : ", err);
    throw err;
  }
};

export const saveSurvey = async (payload: SaveSurveyRequest) => {
  try {
    const response = await axiosClient.post<ApiResponse<SurveyAnswerResponse>>(
      `/survey`,
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error saving survey : ", err);
    throw err;
  }
};

export const getAnswers = async (questionnaire_id: number) => {
  try {
    const response = await axiosClient.post<ApiResponse<SurveyAnswerResponse>>(
      `/survey/view`,
      {
        questionnaire_id,
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching answers : ", err);
    throw err;
  }
};
